module.exports = __webpack_public_path__ + "static/media/phone2.ab43e9f4.png";